import { memo, useEffect } from 'react';
import { buildHandleId } from '../../lib/utils';
import { HANDLES_TYPES, NODES_TYPES } from '../../types';
import { ConditionType } from '@src/components/generated/graphql';
import { INTERACTION_TYPES } from 'util/constants';
import { useUpdateNodeInternals } from '@xyflow/react';
import CustomNode from './CustomNode';
import HandlesWrapper from '../HandlesWrapper';
import styles from '../../timeline-node-manager.module.css';

type CollectibleNodeProps = {
  id: string;
  data: {
    params: {
      interactionType: INTERACTION_TYPES;
      targetId: string;
      audioType?: string;
      animationType?: string;
      title?: string;
      description?: string;
    };
    type: ConditionType.Interaction;
  };
  type: NODES_TYPES;
  selected: boolean;
};

const CollectibleNode = ({
  id,
  data,
  type,
  selected,
}: CollectibleNodeProps) => {
  const updateNodeInternals = useUpdateNodeInternals();

  useEffect(() => {
    updateNodeInternals(id);
  }, [data]);

  return (
    <CustomNode
      id={id}
      type={type}
      data={data}
      label={'Collectible'}
      subtitle={data.params?.title || undefined}
      containerClassname={styles.conditionNode}
      selected={selected}
    >
      <HandlesWrapper
        sources={[
          {
            id: buildHandleId({
              type: 'input',
              handleType: HANDLES_TYPES.QUEST,
              nodeId: id,
            }),
            label: 'Quest',
          },
        ]}
        targets={[
          {
            id: buildHandleId({
              type: 'output',
              handleType: HANDLES_TYPES.COLLECTIBLE,
              nodeId: id,
            }),
            label: 'On Complete',
          },
        ]}
      />
    </CustomNode>
  );
};

export default memo(CollectibleNode);
